import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpUtils } from '../../shared/http-utils';
import { URL_BASE } from '../../core/constants';
import { map } from 'rxjs/operators';
import {Country} from './country.model';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  private COUNTRIES_URI = 'countries';

  constructor(private http: HttpClient) {
  }

  public getAll(): Observable<Country[]> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/${this.COUNTRIES_URI}`;

    return this.http.get(url, { headers })
      .pipe(
        map((countries: any[]) => countries.map(p => Country.fromDto(p)))
      );
  }

  public getAllByRegion(regionId: string): Observable<Country[]> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/${this.COUNTRIES_URI}/by/region/${regionId}`;

    return this.http.get(url, { headers })
      .pipe(
        map((countries: any[]) => countries.map(p => Country.fromDto(p)))
      );
  }
}
